import script from "./workoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./workoutPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__